import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let VerifyDialogComponent = {
    selector: "vcVerifyDialog",
    templateUrl: "/angular/components/campaign/verify-dialog.component.html",
    bindings: {},
    controller: class VerifyDialogController {
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        $onInit() {}

        close(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("campaign")
    .component(VerifyDialogComponent.selector, VerifyDialogComponent);
